/**
 * The clubhouse's areas, in nav order. `MemberNav` and `ClubFooter`'s
 * "The Club" column both render this list, so the two can never disagree —
 * they had: the footer shipped four areas while the nav carried five
 * (decision record §12.4).
 */
export const CLUB_AREAS = [
  { to: '/clubhouse/grounds', label: 'The Grounds' },
  { to: '/clubhouse/register', label: 'The Register' },
  { to: '/clubhouse/lounge', label: 'The Lounge' },
  { to: '/clubhouse/outings', label: 'The Outings' },
  { to: '/clubhouse/record', label: 'The Record' },
  { to: '/clubhouse/wallet', label: 'The Wallet' },
] as const
